module.exports = __webpack_public_path__ + "img/benefit-08-map-compare.90e6ede2.png";